// This file was auto-generated by Fern from our API Definition.
/**
 * Where one attempt stands.
 *
 * `claimed` is the moment between the callback taking the attempt and it writing an
 * outcome, while the code is exchanged. The browser reads it as still pending.
 */
export const McpoAuthAttemptStatus = {
    Pending: "pending",
    Claimed: "claimed",
    Connected: "connected",
    Failed: "failed",
    Cancelled: "cancelled",
};
